import React, { useState, useEffect, useRef } from 'react';
import clsx  from 'clsx';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { useStyles } from './LanguageSwitcherStyles';
import { Us, De, Nl, Fr, Hu, Gr, Id, Ru, Tr, Pl, Hr, Pt, Es, It, Hk, Cn } from '../UI/svg/languageIcons/flags';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

const _languageIcons = {
	en: Us,
	de: De,
	nl: Nl,
	fr: Fr,
	hu: Hu,
	el: Gr,
	id: Id,
	ru: Ru,
	tr: Tr,
	pl: Pl,
	hr: Hr,
	pt: Pt,
	es: Es,
	it: It,
	'zh-tc': Hk,
	'zh-cn': Cn
};

function LanguageSwitcher({ V3, classes, i18n, languages, onChangeLanguage }) {
	const [isOpened, handleToggleMenu] = useState(false);
	const menuRef = useRef(null);
	const language = languages.filter(l => l.lang === i18n.resolvedLanguage)[0] || {};

	useEffect(() => {
		function hideMenu(event) {
			if (menuRef.current && !menuRef.current.contains(event.target)) {
				handleToggleMenu(false);
			}
		}

		document.addEventListener('mousedown', hideMenu);
		return () => {
			document.removeEventListener('mousedown', hideMenu);
		};
	}, [menuRef]);

	const toggleMenu = () => {
		handleToggleMenu(!isOpened);
	};

	const handleChangeLanguage = (l) => {
		cookies.set('userLang', l, { path: '/', domain: (window.location.hostname || '').split('signup.')[1], secure: true });
		onChangeLanguage(l);
		handleToggleMenu(false);
	};

	const renderIcon = lang => {
		const TagName = _languageIcons[lang];
		return _languageIcons[lang] ? <TagName /> : null;
	};

	return (
		<div className={clsx(classes.switcherContainer, {[classes.V3]: V3})} ref={menuRef}>
			<div className={clsx(classes.menuBtn, {[classes.menuBtnActive]: isOpened})} onClick={toggleMenu}>
				{V3 ? 
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clipPath="url(#clip0_3039_35140)">
							<path fillRule="evenodd" clipRule="evenodd" d="M19.6246 12.9H22.1608C21.8515 16.4384 19.7355 19.4589 16.7406 21.0338C16.9117 20.7956 17.0864 20.5382 17.2609 20.2618C18.3524 18.5336 19.4459 16.0524 19.6246 12.9ZM19.6246 11.1H22.1608C21.8515 7.56168 19.7356 4.5412 16.7407 2.96631C16.9118 3.20442 17.0864 3.46177 17.2609 3.73808C18.3525 5.4663 19.4459 7.94752 19.6246 11.1ZM13.3032 1.88247L13.6724 2.19016L13.6771 2.19409L13.7047 2.21821C13.7309 2.24138 13.7724 2.27866 13.8268 2.32985C13.9357 2.43228 14.0964 2.59011 14.2918 2.80178C14.6831 3.22563 15.2104 3.86226 15.7391 4.69927C16.6934 6.21034 17.6459 8.36375 17.8213 11.1H6.17868C6.35414 8.36375 7.30657 6.21034 8.26093 4.69927C8.78957 3.86226 9.31695 3.22563 9.70819 2.80178C9.90358 2.59011 10.0643 2.43228 10.1732 2.32985C10.2276 2.27866 10.2691 2.24138 10.2953 2.21821L10.3229 2.19409L10.3276 2.19016L10.6968 1.88247C11.1235 1.82805 11.5585 1.8 12 1.8C12.4415 1.8 12.8765 1.82805 13.3032 1.88247ZM17.8213 12.9C17.6458 15.6362 16.6934 17.7896 15.7391 19.3006C15.2104 20.1376 14.6831 20.7742 14.2918 21.1981C14.0964 21.4097 13.9357 21.5676 13.8268 21.67C13.7724 21.7212 13.7309 21.7585 13.7047 21.7816L13.6771 21.8058L13.6738 21.8085L13.6723 21.8098L13.303 22.1176C12.8763 22.172 12.4414 22.2 12 22.2C11.5586 22.2 11.1237 22.172 10.697 22.1176L10.3277 21.8098L10.3262 21.8085L10.3229 21.8058L10.2953 21.7816C10.2691 21.7585 10.2276 21.7212 10.1732 21.67C10.0643 21.5676 9.90358 21.4097 9.70819 21.1981C9.31695 20.7742 8.78957 20.1376 8.26093 19.3006C7.3066 17.7896 6.35419 15.6362 6.17869 12.9H17.8213ZM1.83916 11.1H4.37537C4.55406 7.94752 5.64754 5.4663 6.73905 3.73808C6.91357 3.46177 7.08819 3.20442 7.25925 2.96631C4.26443 4.5412 2.14848 7.56168 1.83916 11.1ZM1.83916 12.9H4.37538C4.55411 16.0524 5.64757 18.5336 6.73905 20.2618C6.91362 20.5382 7.08831 20.7956 7.25942 21.0338C4.26453 19.4589 2.14852 16.4384 1.83916 12.9ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z" fill="#525B60"/>
						</g>
						<defs>
							<clipPath id="clip0_3039_35140">
								<rect width="24" height="24" fill="white"/>
							</clipPath>
						</defs>
					</svg>:
					<svg fill="#bfc3ff" height="18" viewBox="0 0 18.66 18.66" width="18" xmlns="http://www.w3.org/2000/svg">
						<path d="M9.33 18.66a9.33 9.33.0 119.33-9.33A9.35 9.35.0 019.33 18.66zm0-17A7.67 7.67.0 1017 9.33 7.68 7.68.0 009.33 1.66z"></path>
						<path d="M5.81 11a1.68 1.68.0 01-.5-.07A3 3 0 013.65 9.15a2.72 2.72.0 00-.46-.74c-.33-.24-1.06-.12-2 .33l-.7-1.5c1.56-.74 2.8-.8 3.67-.18a3.49 3.49.0 011 1.32c.17.34.44.85.63.91a1 1 0 00.61-.22 2.26 2.26.0 00.32-.22l-.23-.31A2.63 2.63.0 015.8 5.86 2.53 2.53.0 018 4.19c.66-.13.69-.15.73-.57a.3.3.0 00-.08-.29C8.49 3.18 7.76 2.7 4.78 3L4.63 1.33c2.72-.26 4.37.0 5.19.84a1.9 1.9.0 01.55 1.62 2.14 2.14.0 01-2.07 2c-.61.12-.81.18-1 .6s0 .59.41 1.1a2 2 0 01.62 1.61 2.18 2.18.0 01-1.14 1.37A2.72 2.72.0 015.81 11z"></path>
						<path d="M11.88 18.23a.81.81.0 01-.42-.12A.83.83.0 0111.17 17c1.17-2 1.34-2.86 1.34-3.22.0-.14-.34-.42-.61-.65a4.11 4.11.0 01-1.76-2.92 2 2 0 01.56-1.67c1-1.07 3-1 4.12-.91h.07a.63.63.0 000-.27c0-.07-.08-.13-.24-.17a2 2 0 00-1 .1 2.4 2.4.0 01-2.14-.2 1.29 1.29.0 01-.65-1c-.07-.71.26-1.7 3.07-4.16A.83.83.0 0115.05 2 .83.83.0 0115 3.15a10.77 10.77.0 00-2.44 2.61 1.06 1.06.0 00.62-.08A3.54 3.54.0 0115 5.56a2 2 0 011.6 2.19 1.56 1.56.0 01-1.42 1.54h-.39c-.58.0-2.35-.12-2.85.4a.43.43.0 00-.1.38A2.54 2.54.0 0013 11.84a2.54 2.54.0 011.2 1.92 8.93 8.93.0 01-1.57 4.07A.83.83.0 0111.88 18.23z"></path>
						<path d="M8.48 18.61a.81.81.0 01-.39-.1.82.82.0 01-.34-1.12 3.59 3.59.0 00.49-1.53l-.31-.12a2.32 2.32.0 01-1-.56A2 2 0 016.49 14c-.07-.54-.12-.76-.59-1s-1.14-.27-3 .48l-.85.36a.83.83.0 11-.67-1.52l.9-.32c1.87-.75 3.28-.9 4.29-.45a2.54 2.54.0 011.56 2.26 3.14 3.14.0 00.06.32s.17.0.29.06A1.74 1.74.0 019.9 15.81a5 5 0 01-.69 2.36A.82.82.0 018.48 18.61z"></path>
					</svg>
				} 
				<span>{language.name}</span>
			</div>
			<div className={classes.dropdown}>
				<ul className={classes.languagesList}>
					{languages.filter(l => l.lang !== i18n.resolvedLanguage).map((l, i) => {
						return (
							<li key={i} onClick={() => handleChangeLanguage(l.lang)}>
								{renderIcon(l.lang)}<span>{l.name}</span>
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
}

LanguageSwitcher.propTypes = {
	V3: PropTypes.bool,
	i18n: PropTypes.object,
	classes: PropTypes.object,
	languages: PropTypes.array,
	onChangeLanguage: PropTypes.func
};

export default withStyles(useStyles)(withNamespaces()(LanguageSwitcher));